import styled from 'styled-components';

import Tabs from 'components/ui/Tabs';

export const Title = styled.h2`
  margin: 0;
  line-height: 40px;
`;

export const StyledTabs = styled(Tabs)`
  margin: 0 0 0 25px;
  height: 42px;
  grid-template-columns: none;
  grid-auto-flow: column;
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 0 20px 0;
`;
